import React from 'react';
import { useOutletContext } from 'react-router-dom';
import CheckerMain from './CheckerMain';

/**
 * Wrapper component that passes outlet context to CheckerMain
 */
function CheckerMainWrapper() {
  const context = useOutletContext();

  return (
    <CheckerMain
      user={context.user}
      hasActiveSubscription={context.hasActiveSubscription}
      subscriptionTier={context.subscriptionTier}
      monthlyChecksUsed={context.monthlyChecksUsed}
      monthlyCheckLimit={context.monthlyCheckLimit}
      checksRemaining={context.checksRemaining}
      canPerformCheck={context.canPerformCheck}
      onCheckPerformed={context.onCheckPerformed}
      onSaveCheck={context.onSaveCheck}
      selectedCheck={context.selectedCheck}
      onNewCheck={context.onNewCheck}
    />
  );
}

export default CheckerMainWrapper;
